import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Product} from '../models/product';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor (
    private db: AngularFirestore,
) { }

  async loadProduts (part_of: number): Promise<any[]> {
    const array: any[] = [];
    try {
      const querySnapshot = await this.db.collection<any>('sbccv_products', ref => ref
        .where('deleted', '==', false)
        .where('available', '==', true)
        .where('part_of', '==', part_of)
        .orderBy('name', 'asc'))
        .get()
        .toPromise();

      querySnapshot.forEach(async (event) => {

        array.push({
          "id": event.id,
          "name": event.data().name,
          "image": event.data().image,
          "part_of": event.data().part_of,
        });
      });
      // Retorna o array após carregado
      return array;
    } catch (error) {
      console.error("Erro loadProduts: ", error);
      throw error;
    }
  }

  getById (id) {
    return this.db.doc<Product>('sbccv_products/' + id)
      .get();
  }

}